/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export const checkIfContainsPath = (currentUrl: string, paths: string[]) =>
  paths.some((url) => currentUrl.includes(url));
